import axios from '../internal/axios';
export var getLicenseHistory = function getLicenseHistory() {
  return axios.get("/payment/licenses").then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};